import React, { useState, useEffect } from "react";
import { Image, Spin } from "antd";
import { fallBackImage } from "../../../../utils/fallbackImage";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./style/viewProperty.css";
import "./style/crf.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import PropTypes from "prop-types";
const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;

const CRF = ({
  disabled,
  data,
  propertyClassifications,
  getPropertyClassifications,
}) => {
  const [time, setTime] = useState({ hrs: 0, min: 0, diff: 0 });
  const [timer, setTimer] = useState(true);
  useEffect(() => {
    const date = new Date(data.change_requests[0].updated_at);
    date.setDate(date.getDate() + 14);
    const a = new Date(date).getTime();
    const b = new Date().getTime();
    const difference = a - b;
    if (difference >= 0) {
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      setTime({
        hrs: hours,
        min: minutes,
        diff: difference,
      });
    }
  }, [data.change_requests]);
  useEffect(() => {
    data?.property_owners.map((value) => {
      if (
        value?.objections[0] ||
        data?.change_requests[0]?.approval_status === "REJECTED" ||
        data?.change_requests[0]?.approval_status === null
      ) {
        setTimer(false);
      }
    });
  }, [data?.property_owners]);
  useEffect(() => {
    if (data.change_requests[0].changed_data.khasra_number_id) {
      getPropertyClassifications({
        valuation_data_id:
          data.change_requests[0].changed_data.khasra_number_id,
      });
    } else {
      getPropertyClassifications({
        valuation_data_id: data.valuation_data_id,
      });
    }
  }, []);

  return (
    <div className="crf">
      <div className="crfRow">
        <div className="crfHeader">Change Request Form (CRF)</div>
      </div>
      {propertyClassifications.length ? (
        <>
          <div>
            {timer ? (
              <div className="crfRow">
                {parseInt(time.diff / (1000 * 3600 * 24)) === 0 &&
                time.hrs === 0 &&
                time.min === 0 ? (
                  <div className="ph1tag">
                    {" "}
                    <InfoCircleOutlined className="infoIcon" />
                    Ph1 will be updated after 12 AM.
                  </div>
                ) : (
                  <div className="ph1tag">
                    <InfoCircleOutlined className="infoIcon" />
                    PH1 will be updated within{" "}
                    {parseInt(time.diff / (1000 * 3600 * 24))} days, {time.hrs}{" "}
                    hrs {time.min} mins
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {data?.change_requests[0]?.approval_status === "REJECTED" ? (
              <div className="crfRow">
                <div className="objectionRemarksHeader">Remarks by ETO</div>
                <div className="objectionRemarks">
                  <p className="remarks">
                    {data?.change_requests[0].rejected_note}
                  </p>
                </div>
              </div>
            ) : (
              <></>
            )}
            {(data?.property_owners).map((value, index) => {
              if (
                value?.objections[0] &&
                data?.change_requests[0]?.approval_status === "APPROVED"
              ) {
                return (
                  <div className="crfRow" key={index}>
                    <div className="objectionRemarksHeader">
                      Remarks by {value?.name}
                    </div>
                    <div className="objectionRemarks">
                      <p className="remarks">{value?.objections[0]?.remarks}</p>
                    </div>
                    <div className="objectionImage">
                      {value?.objections[0]?.documents !== [] &&
                        value?.objections[0]?.documents.map((image, index) => {
                          return (
                            <div className="crfTagimage" key={index}>
                              <Image
                                width={140}
                                height={129}
                                className="crfImage"
                                src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                fallback={fallBackImage}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              }
            })}
          </div>
          {data?.change_requests[0]?.changed_data &&
          (Object.keys(data?.change_requests[0]?.changed_data).length > 1 ||
            (Object.keys(data?.change_requests[0]?.changed_data).length === 1 &&
              !data?.change_requests[0]?.changed_data.atv)) ? (
            <div className="crfRow">
              <div className="crfRowHeader">Basic Details</div>
              {Object.keys(data?.change_requests[0]?.changed_data).map(
                (element, index) => (
                  <div
                    className={
                      element != "documents" &&
                      element != "city_id" &&
                      element != "property_type_id"
                        ? "crfRowData"
                        : ""
                    }
                    key={index}
                  >
                    {element != "documents" &&
                      element != "city_id" &&
                      element != "property_type_id" && (
                        <>
                          {element === "highway_kms" ? (
                            <div className="crfLabel">KMs</div>
                          ) : (
                            element !== "atv" &&
                            element !== "khasra_number_id" &&
                            element !== "mouza_id" &&
                            element !== "tehsil_id" && (
                              <div className="crfLabel">
                                {element.charAt(0).toUpperCase() +
                                  element
                                    .slice(1)
                                    .toString()
                                    .split("_")
                                    .join(" ")}
                              </div>
                            )
                          )}
                          <div className="crfDataValue">
                            {element !== "atv" &&
                              element !== "khasra_number_id" &&
                              element !== "mouza_id" &&
                              element !== "tehsil_id" &&
                              data?.change_requests[
                                data?.change_requests?.length - 1
                              ]?.changed_data[element]}
                          </div>
                        </>
                      )}
                  </div>
                )
              )}
            </div>
          ) : (
            <div></div>
          )}
          { data?.change_requests[0]?.changed_data?.atv&&Object.keys(data?.change_requests[0]?.changed_data?.atv)?.length && (
            <>
              <div className="crfRow">
                <div className="crfRowData">
                {data?.change_requests[0]?.changed_data?.atv?.annual_tax ? (
                  <>
              <div className="crfRowHeader">ATV</div>
                    <div className="crfLabel">Annual Tax</div>
                    <div className="crfDataValue">
                      RS.{" "}
                      {data?.change_requests[0]?.changed_data?.atv?.annual_tax?.toLocaleString()}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {data?.change_requests[0]?.changed_data?.atv
                  ?.annual_taxable_value ? (
                  <>
                    <div className="crfLabel">Annual Taxable Value</div>
                    <div className="crfDataValue">
                      RS.{" "}
                      {data?.change_requests[0]?.changed_data?.atv?.annual_taxable_value?.toLocaleString()}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {data?.change_requests[0]?.changed_data?.atv?.propertyType
                  ?.length && (
                  <>
                    <div className="crfLabel">Classification</div>
                    <div className="crfDataValue">
                      {
                        data?.change_requests[0]?.changed_data?.atv
                          ?.propertyType
                      }
                    </div>
                  </>
                )}
                {data?.change_requests[0]?.changed_data?.atv?.diffObjMobile
                  ?.property_land_areas?.length && (
                  <>
                    <div className="crfLabel">Land Area Changes</div>
                    {data?.change_requests[0]?.changed_data?.atv?.diffObjMobile?.property_land_areas.map(
                      (element, index) => {
                        if (!Array.isArray(element)) {
                          return (
                            //The string below conditionally concatenates the land area, its classification, and the action performed on it.
                            <>
                              <div className="crfDataValue">
                                Area
                                <span
                                  style={
                                    element?.action === "deleted"
                                      ? { color: "red" }
                                      : element?.action === "added"
                                      ? { color: "green" }
                                      : { color: "black" }
                                  }
                                >
                                  {element?.action
                                    ? ` (${
                                        element?.action
                                          .charAt(0)
                                          .toUpperCase() +
                                        element?.action.slice(1)
                                      })`
                                    : ""}
                                </span>
                              </div>
                              <div style={{ marginLeft: "10px" }}>
                                {`${
                                  element?.newVal?.area
                                    ? element?.newVal?.area
                                    : element.area?.newVal
                                    ? element.area?.newVal
                                    : element?.oldVal?.area
                                    ? element?.oldVal?.area
                                    : ""
                                } Marla(s) ${
                                  element?.newVal?.valuation_classification_id
                                    ? propertyClassifications.map(
                                        (nestedElement, nestedIndex) => {
                                          if (
                                            element?.newVal
                                              ?.valuation_classification_id ===
                                            nestedElement?.id
                                          ) {
                                            return nestedElement.name;
                                          }
                                        }
                                      )
                                    : element?.area?.parentObj
                                        ?.valuation_classification?.name
                                    ? element?.area?.parentObj
                                        ?.valuation_classification?.name
                                    : element?.oldVal?.valuation_classification
                                        ?.name
                                    ? element?.oldVal?.valuation_classification
                                        ?.name
                                    : ""
                                }`.replaceAll(",", "")}
                              </div>
                            </>
                          );
                        }
                      }
                    )}
                  </>
                )}
                {false &&
                  data?.change_requests[0]?.changed_data?.atv?.buildings
                    ?.length > 0 && (
                    <>
                      <div className="crfLabel">Building Changes</div>
                      {data?.change_requests[0]?.changed_data?.atv?.buildings?.map(
                        (item, index) => {
                          return (
                            <div key={`${index}-buildings`}>
                              {item?.is_removed && (
                                <>
                                  <div className="crfDataValue">
                                    Building {item?.building_no}
                                    <span style={{ color: "red" }}>
                                      (Removed)
                                    </span>
                                  </div>
                                </>
                              )}{" "}
                              {item?.is_added && (
                                <>
                                  <div className="crfDataValue">
                                    {" "}
                                    Building{item?.building_no}
                                    <span>(Added)</span>
                                  </div>
                                  <span>Floors</span>
                                  <div className="floor-details-buildings">
                                    {item?.data?.map((floor, index) => {
                                      return (
                                        <>
                                          <div>{`Floor ${index + 1}`}</div>
                                          {floor?.non_rcc_area && (
                                            <div>
                                              Non Rcc Area :{" "}
                                              {floor?.non_rcc_area + " Sq-ft"}{" "}
                                            </div>
                                          )}
                                          {floor?.rcc_area && (
                                            <div>
                                              Rcc Area :{" "}
                                              {floor?.rcc_area + " Sq-ft"}{" "}
                                            </div>
                                          )}
                                        </>
                                      );
                                    })}
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        }
                      )}
                    </>
                  )}
                {false &&
                  data?.change_requests[0]?.changed_data?.atv?.floors?.length >
                    0 && (
                    <>
                      <div className="crfLabel">Floor Changes</div>
                      {data?.change_requests[0]?.changed_data?.atv?.floors?.map(
                        (item, index) => {
                          return (
                            <div key={`${index}-floors`}>
                              {item?.is_removed && (
                                <>
                                  <div className="crfDataValue">
                                    Building {item?.building_no} Floor
                                    {item?.floor_no}
                                    <span style={{ color: "red" }}>
                                      (Removed)
                                    </span>
                                  </div>
                                </>
                              )}{" "}
                              {item?.is_added && (
                                <>
                                  <div className="crfDataValue">
                                    {" "}
                                    Building {item?.building_no} Floor
                                    {item?.floor_no}
                                    <span>(Added)</span>
                                    {Object.keys(item)?.map((key) => {
                                      return (
                                        <div className="floor-details-buildings">
                                          {key === "non_rcc_area" &&
                                            item[key] && (
                                              <div>
                                                Non Rcc Area :{" "}
                                                {item["non_rcc_area"] +
                                                  " Sq-ft"}{" "}
                                              </div>
                                            )}
                                          {key === "rcc_area" && item[key] && (
                                            <div>
                                              Rcc Area :{" "}
                                              {item["rcc_area"] + " Sq-ft"}{" "}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </>
                              )}
                              {item?.newValue && item?.propertyName && (
                                <>
                                  <div className="crfLabel">
                                    {" "}
                                    Building {item?.building_no} Floor
                                    {item?.floor_no}
                                  </div>
                                  <div className="crfDataValue">
                                    {item?.propertyName
                                      ?.charAt(0)
                                      ?.toUpperCase() +
                                      item?.propertyName
                                        ?.slice(1)
                                        .toString()
                                        .split("_")
                                        .join(" ") +
                                      " " +
                                      item?.newValue}
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        }
                      )}
                    </>
                  )}
                {data?.change_requests[0]?.changed_data?.atv?.diffObjMobile
                  ?.buildings?.length && (
                  <>
                    <div className="crfLabel">Building Changes</div>
                    {data?.change_requests[0]?.changed_data?.atv?.diffObjMobile?.buildings.map(
                      (element, index) => {
                        if (element !== null && !Array.isArray(element)) {
                          return (
                            <>
                              <div className="crfDataValue">
                                Building{" "}
                                {element?.action === "added"
                                  ? "(New)"
                                  : Number(element?.index) + 1}
                                {element?.action && (
                                  <span
                                    style={
                                      element?.action === "added"
                                        ? { color: "green" }
                                        : element?.action === "deleted"
                                        ? { color: "red" }
                                        : { color: "black" }
                                    }
                                  >
                                    {" "}
                                    {element?.action
                                      ? `(${
                                          element?.action
                                            .charAt(0)
                                            .toUpperCase() +
                                          element?.action.slice(1)
                                        })`
                                      : ""}
                                  </span>
                                )}
                                {element?.newVal !== undefined &&
                                  Object.keys(element?.newVal).length > 0 && (
                                    <>
                                      {element?.newVal?.data?.map(
                                        (element, index) => {
                                          if (
                                            element !== null &&
                                            !Array.isArray(element)
                                          ) {
                                            return (
                                              <>
                                                <div className="floor-details-buildings">
                                                  {`Floor ${
                                                    element?.action ===
                                                      "added" ||
                                                    element?.index === undefined
                                                      ? "(New)"
                                                      : Number(element?.index) +
                                                        1
                                                  } `}
                                                  <span
                                                    style={
                                                      element?.action ===
                                                      "deleted"
                                                        ? { color: "red" }
                                                        : element?.action ===
                                                          "added"
                                                        ? { color: "green" }
                                                        : { color: "black" }
                                                    }
                                                  >
                                                    {element?.action
                                                      ? `(${
                                                          element?.action
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                          element?.action.slice(
                                                            1
                                                          )
                                                        })`
                                                      : ""}
                                                  </span>
                                                  :
                                                  {(element?.rcc_area?.newVal ||
                                                    element?.newVal?.rcc_area ||
                                                    element?.rcc_area) && (
                                                    <div
                                                      style={{
                                                        marginLeft: "20px",
                                                      }}
                                                    >
                                                      RCC:{" "}
                                                      {element?.rcc_area?.newVal
                                                        ? element?.rcc_area
                                                            ?.newVal
                                                        : element?.newVal
                                                            ?.rcc_area
                                                        ? element?.newVal
                                                            ?.rcc_area
                                                        : element?.rcc_area
                                                        ? element?.rcc_area
                                                        : ""}{" "}
                                                      Sq. Ft.
                                                    </div>
                                                  )}
                                                  {(element?.non_rcc_area
                                                    ?.newVal ||
                                                    element?.newVal
                                                      ?.non_rcc_area ||
                                                    element?.non_rcc_area) && (
                                                    <div
                                                      style={{
                                                        marginLeft: "20px",
                                                      }}
                                                    >
                                                      Non-RCC:{" "}
                                                      {element?.non_rcc_area
                                                        ?.newVal
                                                        ? element?.non_rcc_area
                                                            ?.newVal
                                                        : element?.newVal
                                                            ?.non_rcc_area
                                                        ? element?.newVal
                                                            ?.non_rcc_area
                                                        : element?.non_rcc_area
                                                        ? element?.non_rcc_area
                                                        : ""}{" "}
                                                      Sq. Ft.
                                                    </div>
                                                  )}
                                                  {(element
                                                    ?.valuation_classification_id
                                                    ?.newVal ||
                                                    element?.newVal
                                                      ?.valuation_classification_id ||
                                                    element?.valuation_classification_id) && (
                                                    <div
                                                      style={{
                                                        marginLeft: "20px",
                                                      }}
                                                    >
                                                      Classification:{" "}
                                                      {propertyClassifications.map(
                                                        (
                                                          nestedElement,
                                                          nestedIndex
                                                        ) => {
                                                          if (
                                                            element
                                                              ?.valuation_classification_id
                                                              ?.newVal
                                                          ) {
                                                            if (
                                                              element
                                                                ?.valuation_classification_id
                                                                ?.newVal ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else if (
                                                            element?.newVal
                                                              ?.valuation_classification_id
                                                          ) {
                                                            if (
                                                              element?.newVal
                                                                ?.valuation_classification_id ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else if (
                                                            element?.valuation_classification_id
                                                          ) {
                                                            if (
                                                              element?.valuation_classification_id ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else {
                                                            if (
                                                              nestedIndex === 0
                                                            ) {
                                                              return (
                                                                <b>unchanged</b>
                                                              );
                                                            }
                                                          }
                                                        }
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                <div className="floor-details-buildings"></div>
                                              </>
                                            );
                                          }
                                        }
                                      )}
                                    </>
                                  )}
                                {element?.data !== undefined &&
                                  element?.data.length > 0 && (
                                    <>
                                      {element?.data?.map((element, index) => {
                                        if (
                                          element !== null &&
                                          !Array.isArray(element)
                                        ) {
                                          return (
                                            <>
                                              <div className="floor-details-buildings">
                                                {`Floor ${
                                                  element?.action === "added" ||
                                                  element?.index === undefined
                                                    ? "(New)"
                                                    : Number(element?.index) + 1
                                                } `}
                                                <span
                                                  style={
                                                    element?.action ===
                                                    "deleted"
                                                      ? { color: "red" }
                                                      : element?.action ===
                                                        "added"
                                                      ? { color: "green" }
                                                      : { color: "black" }
                                                  }
                                                >
                                                  {element?.action
                                                    ? `(${
                                                        element?.action
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                        element?.action.slice(1)
                                                      })`
                                                    : ""}
                                                </span>
                                                :
                                                {(element?.rcc_area?.newVal ||
                                                  element?.newVal?.rcc_area ||
                                                  element?.rcc_area) && (
                                                  <div
                                                    style={{
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    RCC:{" "}
                                                    {element?.rcc_area?.newVal
                                                      ? element?.rcc_area
                                                          ?.newVal
                                                      : element?.newVal
                                                          ?.rcc_area
                                                      ? element?.newVal
                                                          ?.rcc_area
                                                      : element?.rcc_area
                                                      ? element?.rcc_area
                                                      : ""}{" "}
                                                    Sq. Ft.
                                                  </div>
                                                )}
                                                {(element?.non_rcc_area
                                                  ?.newVal ||
                                                  element?.newVal
                                                    ?.non_rcc_area ||
                                                  element?.non_rcc_area) && (
                                                  <div
                                                    style={{
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    Non-RCC:{" "}
                                                    {element?.non_rcc_area
                                                      ?.newVal
                                                      ? element?.non_rcc_area
                                                          ?.newVal
                                                      : element?.newVal
                                                          ?.non_rcc_area
                                                      ? element?.newVal
                                                          ?.non_rcc_area
                                                      : element?.non_rcc_area
                                                      ? element?.non_rcc_area
                                                      : ""}{" "}
                                                    Sq. Ft.
                                                  </div>
                                                )}
                                                {(element
                                                  ?.valuation_classification_id
                                                  ?.newVal ||
                                                  element?.newVal
                                                    ?.valuation_classification_id ||
                                                  element?.valuation_classification_id) && (
                                                  <div
                                                    style={{
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    Classification:{" "}
                                                    {propertyClassifications.map(
                                                      (
                                                        nestedElement,
                                                        nestedIndex
                                                      ) => {
                                                        if (
                                                          element
                                                            ?.valuation_classification_id
                                                            ?.newVal
                                                        ) {
                                                          if (
                                                            element
                                                              ?.valuation_classification_id
                                                              ?.newVal ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else if (
                                                          element?.newVal
                                                            ?.valuation_classification_id
                                                        ) {
                                                          if (
                                                            element?.newVal
                                                              ?.valuation_classification_id ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else if (
                                                          element?.valuation_classification_id
                                                        ) {
                                                          if (
                                                            element?.valuation_classification_id ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else {
                                                          if (
                                                            nestedIndex === 0
                                                          ) {
                                                            return (
                                                              <b>unchanged</b>
                                                            );
                                                          }
                                                        }
                                                      }
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              <div className="floor-details-buildings"></div>
                                            </>
                                          );
                                        }
                                      })}
                                    </>
                                  )}
                              </div>
                            </>
                          );
                        }
                      }
                    )}
                  </>
                )}
                </div>
              </div>
            </>
          )}
          {data?.change_requests[0]?.property_owners.length > 0 && (
            <div className="crfRow">
              <div className="crfRowHeader">Property Owners</div>
              {(data?.change_requests[0]?.property_owners).map(
                (value, index) => {
                  return (
                    <div className="crfRowData" key={index}>
                      {value.removed ? (
                        <>
                          <div className="crfLabel">{index + 1}. Name</div>
                          <div className="crfRowHeader">
                            {value?.name + " "}
                            <span style={{ color: "red" }}>(Removed)</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="crfRowData">
                            <div className="crfLabel">{index + 1}. Name</div>
                            <div className="crfRowHeader">
                              {value?.name + " "}
                            </div>
                          </div>
                          {value?.father_name ? (
                            <div className="crfRowData">
                              <div className="crfLabel">Father Name</div>
                              <div className="crfDataValue">
                                {value?.father_name ? value?.father_name : ""}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {value?.email ? (
                            <div className="crfRowData">
                              <div className="crfLabel">Email</div>
                              <div className="crfDataValue">{value?.email}</div>
                            </div>
                          ) : (
                            ""
                          )}
                          {value?.cnic ? (
                            <div className="crfRowData">
                              <div className="crfLabel">CNIC</div>
                              <div className="crfDataValue">{value.cnic}</div>
                            </div>
                          ) : (
                            ""
                          )}
                          {value?.phone_number ? (
                            <div className="crfRowData">
                              <div className="crfLabel">Phone Number</div>
                              <div className="crfDataValue">
                                {value.phone_number}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {value?.shares ? (
                            <div className="crfRowData">
                              <div className="crfLabel">Share</div>
                              <div className="crfDataValue">
                                {value.shares} %
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {value?.documents && value?.documents?.length > 0 ? (
                            <div className="crfRowData">
                              <div className="crfLabel">Document Proof</div>
                              {value.documents.map((image, index) => {
                                return (
                                  <div className="crfTagimage" key={index}>
                                    <Image
                                      width={100}
                                      height={100}
                                      className="crfImage"
                                      src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                      fallback={fallBackImage}
                                    />
                                    {image?.removed ? (
                                      <span className="crfRemovedTag">
                                        Removed
                                      </span>
                                    ) : (
                                      <span className="crfApprovedTag">
                                        Added
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                  );
                }
              )}
            </div>
          )}
          {data?.change_requests[0]?.occupiers.length > 0 && (
            <div className="crfRow">
              <div className="crfRowHeader">Occupiers</div>
              {(data?.change_requests[0]?.occupiers).map((value, index) => {
                return (
                  <div className="crfRowData" key={index}>
                    {value.removed ? (
                      <>
                        <div className="crfLabel">{index + 1}. Name</div>
                        <div className="crfRowHeader">
                          {value?.name + " "}
                          <span style={{ color: "red" }}>(Removed)</span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="crfRowData">
                          <div className="crfLabel">{index + 1}. Name</div>
                          <div className="crfRowHeader">
                            {value?.name + " "}
                          </div>
                        </div>
                        {value?.father_name ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Father Name</div>
                            <div className="crfDataValue">
                              {value?.father_name}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.email ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Email</div>
                            <div className="crfDataValue">{value?.email}</div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.cnic ? (
                          <div className="crfRowData">
                            <div className="crfLabel">CNIC</div>
                            <div className="crfDataValue">{value.cnic}</div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.business_name ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Business Name</div>
                            <div className="crfDataValue">
                              {value.business_name}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.phone_number ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Phone Number</div>
                            <div className="crfDataValue">
                              {value.phone_number}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.is_renter !== null &&
                        value?.is_renter !== undefined ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Self/Rented</div>
                            <div className="crfDataValue">
                              {value.is_renter ? "Rented" : "Self"}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {value?.documents && value?.documents?.length > 0 ? (
                          <div className="crfRowData">
                            <div className="crfLabel">Document Proof</div>
                            {value.documents.map((image, index) => {
                              return (
                                <div className="crfTagimage" key={index}>
                                  <Image
                                    width={140}
                                    height={129}
                                    className="crfImage"
                                    src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                    fallback={fallBackImage}
                                  />
                                  {image?.removed ? (
                                    <span className="crfRemovedTag">
                                      Removed
                                    </span>
                                  ) : (
                                    <span className="crfApprovedTag">
                                      Added
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {data?.change_requests[0]?.documents.length > 0 && (
            <div className="crfRow">
              <div className="crfRowHeader">Images</div>
              <div className="crfImageContainer">
                {(data?.change_requests[0]?.documents).map((image, index) => {
                  return (
                    <div className="crfTagimage" key={index}>
                      <Image
                        width={100}
                        height={100}
                        className="crfImage"
                        src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                        fallback={fallBackImage}
                      />
                      {image?.removed ? (
                        <span className="crfRemovedTag">Removed</span>
                      ) : (
                        <span className="crfApprovedTag">Added</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};
const mapStateToProps = ({ dropDown: { propertyClassifications } }) => ({
  propertyClassifications,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyClassifications: bindActionCreators(
    dropDownActions.getPropertyClassifications,
    dispatch
  ),
});

CRF.propTypes = {
  propertyClassifications: PropTypes.array.isRequired,
  getPropertyClassifications: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(CRF);
